<template>
  <div class="project-form">
    <el-form ref="form" :model="projectDynamicForm">
        <!-- 防水项目名称选择 -->
        <el-form-item label="防水项目名称">
          <div style="display: flex; align-items: center;">
            <el-input v-model="projectDynamicForm.name" placeholder="请输入防水项目名称" disabled
              style="flex: 1; min-width: 200px;"></el-input>
          </div>
        </el-form-item>

        <!-- 动态表单配置部分 -->
        <el-form-item label="防水服务阶段">
          <el-card>
            <div v-for="(stage, stageIndex) in projectStages" :key="stageIndex">
              <el-table :data="stage.forms" border style="width: 100%; margin-top: 20px">
                <el-table-column prop="stageName" label="服务阶段名称" min-width="50">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.stageName" placeholder="请输入服务阶段名称" disabled></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="拿货价" min-width="50">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.price" placeholder="请输入拿货价" disabled></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="threshold" label="阈值" min-width="50">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.threshold" placeholder="请输入阈值" disabled></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序" min-width="200">
                  <template v-slot="scope">
                    <el-input-number v-model="scope.row.sort" placeholder="请输入排序" disabled></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="表单配置" min-width="900">
                  <template v-slot="scope">
                    <el-table :data="scope.row.formFields" border style="width: 100%">
                      <el-table-column label="字段名称" width="150">
                        <template v-slot="innerScope">
                          <el-input v-model="innerScope.row.fieldName" placeholder="字段名称" disabled></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="控件类型" width="150">
                        <template v-slot="innerScope">
                          <el-select v-model="innerScope.row.inputType" placeholder="请选择控件类型" disabled>
                            <el-option v-for="type in inputTypes" :key="type.id" :label="type.name"
                              :value="type.id"></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column label="数据源" width="150">
                        <template v-slot="innerScope">
                          <el-select v-model="innerScope.row.dataSource" placeholder="请选择数据源" disabled>
                            <el-option v-for="source in dataSources" :key="source.id" :label="source.valueName"
                              :value="source.id"></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column label="是否为空">
                        <template v-slot="innerScope">
                          <el-radio-group v-model="innerScope.row.isNull" disabled>
                            <el-radio label="YES">是</el-radio>
                            <el-radio label="NO">否</el-radio>
                          </el-radio-group>
                        </template>
                      </el-table-column>
                       <!-- 是否计费 -->
                    <el-table-column label="是否计费" width="150">
                      <template v-slot="innerScope">
                        <el-radio-group v-model="innerScope.row.charging" disabled>
                          <el-radio label="YES">是</el-radio>
                          <el-radio label="NO">否</el-radio>
                        </el-radio-group>
                      </template>
                    </el-table-column>
                    <el-table-column label="输入计费规则" width="150">
                      <template v-slot="innerScope">
                        <el-input v-model="innerScope.row.expression" placeholder="请输入计费规则" clearable disabled></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="排序" width="150">
                      <template v-slot="innerScope">
                        <el-input v-model="innerScope.row.sort" disabled></el-input>
                      </template>
                    </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item align="center">
          <el-button type="text" @click="handleCancel" icon="el-icon-close">取消</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
import { findWaterProofDynamicId, findDataSourceAll, findDataSourceFields, editWaterProofDynamic } from "@/api/work/waterProof/projectDynamic";
import ImageUpload from "@/components/imageUpload/ImageUpload";

export default {
  name: 'EditForm',
  components: {
    ImageUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: String,
      required: true
    },
    agentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      projectDynamicForm: { name: '' },
      projectStages: [],
      inputTypes: [],
      dataSources: [],
      additionalFields: {},
      typeClients: [
        {
          label: "工程师端",
          value: "JOINS_ENGINEER",
        },
        {
          label: "消费者端",
          value: "JOINS_USER",
        },
        {
          label: "商户端",
          value: "JOINS_MERCHANT",
        }
      ],
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal && this.projectId) {
          this.getProjectDetail();
        }
      },
      immediate: true
    },
    projectId: {
      handler(newVal) {
        if (newVal && this.visible) {
          this.getProjectDetail();
        }
      }
    }
  },
  created() {
    findDataSourceFields().then(res => {
      this.inputTypes = JSON.parse(res.data);
    });

    findDataSourceAll().then(res => {
      this.dataSources = JSON.parse(res.data).rows;
    });

    if (this.projectId && this.visible) {
      this.getProjectDetail();
    }
  },
  methods: {
    getProjectDetail() {
      // 添加日志，帮助调试
      console.log('获取项目详情，projectId:', this.projectId, 'agentId:', this.agentId);
      
      // 重置项目阶段数据，避免叠加旧数据
      this.projectStages = [];
      this.projectDynamicForm.name = '';
      
      findWaterProofDynamicId(this.projectId).then(res => {
        console.log('获取项目详情响应:', res);
        
        if (res && (res.code === '200' || res.code === 200)) {
          try {
            const parsedData = JSON.parse(res.data);
            console.log('解析后的数据:', parsedData);
            
            // 处理数据结构，确保正确获取rows数组中的第一条数据
            const data = parsedData.rows && parsedData.rows.length > 0 ? parsedData.rows[0] : parsedData;
            
            if (!data) {
              console.error('未找到项目数据');
              this.$message.error('未找到项目数据');
              return;
            }
            
            this.projectDynamicForm.name = data.name || '';
            this.additionalFields = { ...data };
            
            // 检查list是否存在且为数组
            if (data.list && Array.isArray(data.list)) {
              this.projectStages = data.list.map(stage => ({
                forms: [{
                  ...stage,
                  stageName: stage.name || '',
                  price: stage.price || '',
                  threshold: stage.threshold || '',
                  sort: stage.sort || 0,
                  id: stage.id || '',
                  formFields: (stage.dynamicFormRequest && stage.dynamicFormRequest.fields ? stage.dynamicFormRequest.fields.map(field => {
                    const foundType = this.inputTypes.find(type => type.id == field.inputType);
                    return {
                      ...field,
                      id: field.id || '',
                      fieldName: field.fieldName || '',
                      inputType: foundType ? foundType.id : '',
                      dataSource: field.dataSource || '',
                      isNull: field.isNull || 'NO',
                      showFlag: field.showFlag || 'YES',
                      showClient: field.showClient ? field.showClient.split(',') : [],
                      charging: field.charging || 'NO',
                      expression: field.expression || '',
                      sort: field.sort || 0,
                    };
                  }) : []),
                }],
              }));
              console.log('处理后的项目阶段数据:', this.projectStages);
            } else {
              console.warn('项目数据中没有list或不是数组，使用空数组');
              this.projectStages = [];
            }
          } catch (error) {
            console.error('解析数据时出错:', error);
            this.$message.error('解析数据失败');
          }
        } else {
          console.error('请求失败，响应码:', res.code, '消息:', res.message);
          this.$message.error(res.message || '获取项目详情失败');
        }
      }).catch(error => {
        console.error('获取项目详情接口调用失败:', error);
        this.$message.error('请求失败，请稍后重试');
      });
    },
    handleUploaded(urls, stageIndex, fieldIndex) {
      this.projectStages[stageIndex].forms[0].formFields[fieldIndex].picUrl = urls;
    },
    addStage() {
      this.projectStages.push({
        forms: [{
          stageName: '',
          sort: '',
          formFields: [{
            fieldName: '',
            inputType: '',
            dataSource: '',
            isNull: 'NO',
            picUrl: [],
          }],
        }],
      });
    },
    removeStage(stageIndex) {
      this.projectStages.splice(stageIndex, 1);
    },
    addField(stageIndex) {
      this.projectStages[stageIndex].forms[0].formFields.push({
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: 'NO',
        picUrl: [],
      });
    },
    removeField(stageIndex, fieldIndex) {
      this.projectStages[stageIndex].forms[0].formFields.splice(fieldIndex, 1);
    },
    submit() {
      const params = {
        ...this.additionalFields,
        id: this.projectId,
        agentId: this.agentId,
        name: this.projectDynamicForm.name,
        type: 'WATERPROOF_PROJECT',
        list: this.projectStages.map(stage => ({
          ...stage.forms[0],
          name: stage.forms[0].stageName,
          sort: stage.forms[0].sort,
          type: 'WATERPROOF_PROJECT',
          id: stage.forms[0].id ? stage.forms[0].id : '',
          dynamicFormRequest: {
            ...stage.forms[0].dynamicFormRequest,
            fields: stage.forms[0].formFields.map(field => ({
              ...field,
              id: field.id ? field.id : '',
              fieldName: field.fieldName,
              inputType: field.inputType,
              dataSource: field.dataSource,
              isNull: field.isNull,
              picUrl: field.picUrl.map(url => (typeof url === 'string' ? url : url.url)).join(','),
            })),
          },
        })),
      };
      
      editWaterProofDynamic(params).then(res => {
        if (res.code === '200') {
          this.$message.success('修改成功');
          this.$emit('submit-success');
          this.$emit('close');
        } else {
          this.$message.error(res.message || '修改失败');
        }
      }).catch(error => {
        this.$message.error('请求失败: ' + error.message);
      });
    },
    handleCancel() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.project-form {
  padding: 10px;
  max-height: 70vh;
  overflow-y: auto;
}
</style>
